export default __webpack_public_path__ + "static/media/teacher.8ce9da7f.svg";